import { landingPageContentGql } from '../../matrix_blocks/landingPageContentGql.js';
import { linksMatrixGql } from '../../link_field/linksMatrixGql.js';
import { blogEntryFilterGql } from './blogEntryFilterGql.js';

const pageGql = `id
title
... on blog_Category {
  featuredPost{
    ... on blog_blog_Entry{
      title
      articleSummary
      url
      featuredImage: blogFeaturedImage{
        title
        ... on blogNews_Asset {
          filterPageFeaturedImage {
            srcsetWebp
            srcset
          }
        }
      }
    }
  }
  blogCategorySubhead
  blogCategoryDescription
  breadcrumbLink {
    uri
  }
  sidebarNavigationLinks: ${linksMatrixGql(2)}
  filters: blogFilters(orderBy: "lft asc") {
    title
    slug
    level
    parent {
      slug
    }
  }
  filterPageOverviewSubhead
  filterPageOverviewDescription
  links: ${linksMatrixGql()}
  searchFieldPlaceholder
  relatedProductCategories(orderBy: "lft asc") {
    id
    level
  }
  ${landingPageContentGql}
}
seomatic(asArray: true) {
  metaTitleContainer
  metaLinkContainer
  metaScriptContainer
  metaJsonLdContainer
  metaTagContainer
}`;

export const pageQuery = `query($site: String, $uri: String) {
  category(site: [$site], uri: [$uri]) {
    ${pageGql}
  }
}`;

export const blogFilterGenerateQuery = function (sitesString = `$site`) {
  return `query {
    categories(
      site: [${sitesString}]
      group: ["blog"]
    ) {
      groupHandle
      siteId
      uri
      ${pageGql}
    }
  }`;
};

export const resultsQuery = `query($id: QueryArgument, $orderBy:String, $site: String) {
  entries(
    blogFilterPages: [$id]
    orderBy: $orderBy
    section: "blog"
    site: [$site]
    type: ["blog", "customerStory"]
  ) {
    title
    url
    entryPostDate: postDate @formatDateTime (format: "F d, Y")
    filterByDate: postDate  @formatDateTime (format: "D M d Y H:i:s O")
    typeHandle
    ... on blog_blog_Entry {
      ${blogEntryFilterGql}
      blogContent {
        ... on blogContent_text_BlockType {
          text
        }
      }
    }
    ... on blog_customerStory_Entry {
      ${blogEntryFilterGql}
      customerStoryContent {
        ... on customerStoryContent_header_BlockType {
          leadParagraph
        }
        ... on customerStoryContent_text_BlockType {
          text
        }
      }
    }
  }
}`;
